import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser'
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import SelectLevel from './SelectLevel';
import GameTitleText from '../gameobjects/GameTitleText';
import FontKeys from '../FontKeys';


export default class MathInstructions extends Phaser.Scene
{
    static get KEY() { return 'MathInstructions'; }

    constructor()
    {
        super({ key: (MathInstructions).KEY });
    }

    create()
    {
        const { gameConfig } = ABCyaLib.Environment.instance;
        const bg = this.add.rectangle(0,0, this.scale.width, this.scale.height, 0x0f75bc).setOrigin(0);

        const title = new GameTitleText(this, this.scale.width / 2, 150, 0.75, 60);

        const firstLineText = ABCyaPhaser.Text.addText(this.scale.width/2, 322, gameConfig.instructionFontSize, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.instructions.first_line"), this, true).setOrigin(0.5);
        const secondLineText = ABCyaPhaser.Text.addText(this.scale.width/2, 394, gameConfig.instructionFontSize, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.instructions.second_line"), this, true).setOrigin(0.5);
        const thirdLineText = ABCyaPhaser.Text.addText(this.scale.width/2, 465, gameConfig.instructionFontSize, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.instructions.third_line"), this, true).setOrigin(0.5);
        const fourthLineText = ABCyaPhaser.Text.addText(this.scale.width/2, 539, gameConfig.instructionFontSize, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.instructions.fourth_line"), this, true).setOrigin(0.5);

        this.nextButton = ABCyaPhaser.Buttons.addSimpleButton(this.scale.width / 2 + 430, this.scale.height - 75, UIAssetKeys._sprites_go_button, null, () =>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            this.scene.start(SelectLevel.KEY);
        }, this).setScale(0.6);

        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 500, { scale: 1, offset: 100 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 200, { scale: 0.6, offset: 600 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
            }
        );
    }
}